import type { ScoreItem } from '@talentmesh/utils';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import BenchmarkPanel from './Components/Benchmark/BenchmarkPanel';
import ScoreOverview from './Components/ScoreOverview';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

function SkillsTab() {
    const { results, jobFunction } = useCandidatesResultsContext();
    const { skillsScore, candidateFirstName } = results;

    if (!skillsScore) {
        return null;
    }

    const { percentileScore, percentileLevel } = skillsScore;

    const overall: ScoreItem = {
        level: percentileLevel,
        name: UIStrings.OverallScore,
        value: percentileScore,
    };

    const scores: ScoreItem[] = skillsScore.scores.map((score) => {
        return {
            level: score.percentileLevel,
            name: score.questionTopicName,
            value: score.percentileScore,
        };
    });

    return (
        <div className="mb-5 flex flex-col gap-5">
            <ScoreOverview
                scoreOverviewTitle={UIStrings.SkillsScoreOverview}
                scoreOverviewDescription={UIStrings.TheOverallScoreIsCalculatedBasedOnSkills(jobFunction)}
                candidateFirstName={candidateFirstName}
                scores={scores}
                overall={overall}
            />
            <BenchmarkPanel
                testType={TestTypes.Skills}
                candidateFirstName={candidateFirstName}
                candidateScore={skillsScore}
            />
        </div>
    );
}

export default SkillsTab;
